import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Tooltip} from '@material-ui/core';
import {Icon} from 'front-onceforall-core';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';
import authenticationService from '../../../../../../../services/authentication/AuthenticationService';
import {SIGN_PERMISSION, AUTO_GENERATE_FILE_DOCUMENT_TYPE} from '../../../../../../../utils/constant';

function ActionView({document, onClick}) {
  const isSignAction =
    document.state === DOCUMENT_STATE.AWAITING_SIGNATURE ||
    document.type.code === AUTO_GENERATE_FILE_DOCUMENT_TYPE;
  const roles = authenticationService.roles();

  // Sign action needs sign permission (thanks captain obvious)
  // Other actions need manager role
  if (
    (isSignAction && !roles.hasPermission(SIGN_PERMISSION)) ||
    (!isSignAction && !roles.isManager())
  ) {
    return null;
  }

  return (
    <Tooltip
      title={<Translate value={`dashboard.documentsToProcess.action.${isSignAction ? 'sign' : 'upload'}`}/>}
      placement="top"
    >
      <span>
        <button
          className="button-square information-primary"
          onClick={onClick}
        >
          <Icon icon={isSignAction ? 'sign' : 'upload-document'}/>
        </button>
      </span>
    </Tooltip>
  );
}

ActionView.propTypes = {
  document: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ActionView;
